import { render, staticRenderFns } from "./WhitelabelInvestiment.vue?vue&type=template&id=0587933d&scoped=true"
import script from "./WhitelabelInvestiment.vue?vue&type=script&lang=js"
export * from "./WhitelabelInvestiment.vue?vue&type=script&lang=js"
import style0 from "./WhitelabelInvestiment.vue?vue&type=style&index=0&id=0587933d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587933d",
  null
  
)

export default component.exports